"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolutionError = void 0;
// To be thowable this needs to extend error
class ResolutionError extends Error {
    constructor(message, undefinedIdentifiers) {
        super(message);
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ResolutionError.prototype);
        this.name = "ResolutionError";
        this._undefinedIdentifiers = undefinedIdentifiers;
    }
    get undefinedIdentifiers() {
        return this._undefinedIdentifiers;
    }
}
exports.ResolutionError = ResolutionError;
//# sourceMappingURL=resolutionError.js.map